import React from 'react';
import { Card, Typography, Row, Col } from 'antd';

const { Title, Paragraph } = Typography;

export const Features = ({ setLoading, showMessage }) => {
    const features = [
        {
            title: 'مدیریت رزرو اتاق',
            items: ['رزرو آنلاین', 'مدیریت افراد', 'کنترل محدودیتهای ثبت نام', 'کنترل ظرفیت اتاقها']
        },
        {
            title: 'مدیریت فرآیند ثبت نام',
            items: ['تایید رزرو', 'پرداخت آنلاین', 'ارسال آنلاین مدارک', 'قزعه کشی آنلاین']
        },
        {
            title: 'مدیریت فرآیند رزرو غذا',
            items: ['تایید رزرو غذا', 'پرداخت آنلاین', 'کنترل ظرفیت و تاریخ', 'رزرو آنلاین غذا']
        },
        {
            title: 'مدیریت رزرو پارکینگ',
            items: ['تایید رزرو پارکینگ', 'پرداخت آنلاین', 'کنترل ظرفیت و تاریخ', 'رزرو آنلاین پارکینگ']
        },
        {
            title: 'مدیریت کاربران',
            items: ['پروفایل مهمان', 'تاریخچه اقامت', 'نظرسنجی']
        },
        {
            title: 'گزارش‌گیری',
            items: ['گزارش پارکینگ','گزارش آشپزخانه', 'گزارش اتاقها', 'گزارش پرداختها', 'گزارش ثبت نامها']
        },
        {
            title: 'گزارشهای پذیرش',
            items: ['گزارش پذیرش', 'گزارش تهیه غذای رستوران', 'گزارش خروجی ها', 'گزارش ورودیها']
        },
        {
            title: 'امنیت',
            items: ['احراز هویت با موبایل', 'پشتیبان‌گیری', 'لاگ فعالیت‌ها']
        }
    ];

    return (
        <div style={{ padding: 24 }}>
            <Card>
                <Title level={2}>امکانات و قابلیت‌های برنامه</Title>
                <Paragraph type="secondary" style={{ marginBottom: 32 }}>
                    سیستم مدیریت رزرو تاق در حسینیه نجف آبادیها (مشهد مقدس) امکانات کامل و رابط کاربری مدرن
                </Paragraph>
                
                <Row gutter={[16, 16]}>
                    {features.map((feature, index) => (
                        <Col xs={24} sm={12} md={8} key={index}>
                            <Card 
                                title={feature.title}
                                hoverable
                                style={{ height: '100%' }}
                            >
                                <ul style={{ paddingRight: 20 }}>
                                    {feature.items.map((item, idx) => (
                                        <li key={idx} style={{ marginBottom: 8 }}>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>
        </div>
    );
};